import React, {
    useCallback,
    useContext,
    useEffect,
    useMemo,
    useState,
} from "react";
import { useWindowSize } from "../../../common/hooks/useWindowSize";
import usePermissions from "../../../common/hooks/usePermissions";
import { UserSettingsContext } from "../../../setup/routes-manager/RequireAuth";
import { CHART_SCREEN_TYPE } from "../../../common/utility/mp_chart_constants";
import {
    getIvRangeBottomPanelVisibleName,
    getIvRangeBottomPanelHeightName,
} from "../../../common/utility/helperFunc";
import { MIN_CHART_WIDTH } from "../../../common/utility/constant";
import MPChartRightPanel from "../components/mpchart_right_panel";
import IvRangeChart, { IV_RANGE_BOTTOM_HEIGHT_DEFAULT } from "./IvRangeChart";
import "../styles/styles.scss";
import "./IvRange.css";

const RIGHT_RAIL_WIDTH = 51;


const IvRange = ({
    chartStateData: chartStateDataProp,
    apiPayload,
    liveData,
    symbol = "NIFTY",
    plot = "spt_ivr",
    isTradingSessionActive = false,
    isPollingAllowed = false,
    isInstrumentLive = false,
    isLivePollingAllowed = false,
    lastPollTime,
    boundClass = ".of_chart-container-new",
    isDrawingEnabled = false,
    selectedTool = null,
    drawingObjects,
    setDrawingObjects,
    disableDrawing,
    isDrawingToolAllowed = false,
    onSelectDrawingTool,
}) => {
    const windowSize = useWindowSize();
    const permissions = usePermissions();
    const isBasicUser = permissions.isFreeUser();
    const isProUser = permissions.isPremiumUser();

    const { userSettings } = useContext(UserSettingsContext);

    const visibleKey = useMemo(
        () => getIvRangeBottomPanelVisibleName(plot),
        [plot],
    );
    const heightKey = useMemo(
        () => getIvRangeBottomPanelHeightName(plot),
        [plot],
    );

    const showBottomPanel =
        userSettings.data[visibleKey] !== undefined
            ? userSettings.data[visibleKey]
            : true;
    const bottomPanelHeightPercent =
        userSettings.data[heightKey] !== undefined
            ? userSettings.data[heightKey]
            : IV_RANGE_BOTTOM_HEIGHT_DEFAULT;

    useEffect(() => {
        document.title = "IV Range";
    }, []);

    const [containerState, setContainerState] = useState({
        loaded: false,
        chartStateData: { top: 0, left: 0, width: 0, height: 0 },
    });

    useEffect(() => {
        if (chartStateDataProp) {
            setContainerState({
                loaded: true,
                chartStateData: chartStateDataProp,
            });
            return;
        }

        const width = Math.floor(window.innerWidth - RIGHT_RAIL_WIDTH);
        const height = Math.floor(window.innerHeight - 48);
        setContainerState({
            loaded: true,
            chartStateData: { top: 0, left: 0, width, height },
        });
    }, [chartStateDataProp, windowSize]);

    const resetRightPanel = useCallback(() => {}, []);
    const closeRightPanelModal = useCallback(() => {}, []);
    const openLivePanel = useCallback(() => {}, []);
    const noopSubscribe = useCallback(() => {}, []);
    const noopScreenType = useCallback(() => {}, []);
    const noopWatchlist = useCallback(() => {}, []);

    const { loaded, chartStateData } = containerState;

    return (
        <div style={{ width: "100%", height: "100%" }}>
            {loaded ? (
                <>
                    <div
                        className="of_chart-container-new"
                        style={{
                            userSelect: "none",
                            height: `calc(${chartStateData.height}px)`,
                            width: `calc(${chartStateData.width}px)`,
                            minWidth: MIN_CHART_WIDTH,
                            minHeight: "calc(110vh - 256px)",
                        }}
                    >
                        <IvRangeChart
                            boundClass={boundClass}
                            chartStateData={chartStateData}
                            apiPayload={apiPayload}
                            liveData={liveData}
                            instrument={symbol}
                            isTradingSessionActive={isTradingSessionActive}
                            isPollingAllowed={isPollingAllowed}
                            isInstrumentLive={isInstrumentLive}
                            isLivePollingAllowed={isLivePollingAllowed}
                            lastPollTime={lastPollTime}
                            showBottomPanel={showBottomPanel}
                            bottomPanelHeightPercent={bottomPanelHeightPercent}
                            isDrawingEnabled={isDrawingEnabled}
                            selectedTool={selectedTool}
                            drawingObjects={drawingObjects}
                            setDrawingObjects={setDrawingObjects}
                            disableDrawing={disableDrawing}
                            isDrawingToolAllowed={isDrawingToolAllowed}
                            onSelectDrawingTool={onSelectDrawingTool}
                        />
                    </div>
                    <MPChartRightPanel
                        toggleLiveButton={false}
                        isLiveEnabled={false}
                        resetRightPanel={resetRightPanel}
                        closeModal={closeRightPanelModal}
                        showLive={false}
                        openLivePanel={openLivePanel}
                        isBasicUser={isBasicUser}
                        proUser={isProUser}
                        openSubscribeModal={noopSubscribe}
                        chartScreenType={CHART_SCREEN_TYPE.FULL_CHART}
                        basicUser={isBasicUser}
                        setChartScreenType={noopScreenType}
                        toggleWatchlist={noopWatchlist}
                    />
                </>
            ) : null}
        </div>
    );
};

export default IvRange;
